import { Box } from "@mui/material";

const acceptedTypes = ["youtube"];
export default function EmbeddedVideo({ video, videoType = "youtube" }) {
  if (!acceptedTypes.includes(videoType)) {
    throw new Error(`Invalid video type provided: ${videoType}`);
  }

  if (videoType == "youtube") {
    return (
      <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <iframe
          style={{
            width: "80vw",
            height: "40vh",
          }}
          src={video.embed_link}
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        />
      </Box>
    );
  }
}
